<script>
    import { apiHost, token } from "./stores";
    const openGame = (id) =>
        (location = `${apiHost}game/${id}?token=${$token}`);
    export let image = null;
    export let hover = null;
    export let width = 36;
    export let height = width * 1.35;
    export let x = 6.5;
    export let y = 19;
    export let game;
    $: styles = [
        `--image:url(../assets/games/${image}?t=buildTime)`,
        `--hover:url(../assets/games/${hover}?t=buildTime)`,
        `--x:${x}vw`,
        `--y:${y}vh`,
        `--width:${width}vw`,
        `--height:${height}vh`,
        `--height2:${height * 2}vh`,
    ];
</script>

<div role="presentation" style={styles.join(";")} on:click={() => openGame(game)} />

<style>
    div {
        position: absolute;
        top: var(--y);
        left: var(--x);
        width: var(--width);
        height: var(--height);
        background-image: var(--image);
        background-size: var(--width) var(--height2);
        background-position: 0 0;
    }
    div:hover {
        background-position: 0 var(--height);
    }
</style>
